module.exports = __webpack_public_path__ + "static/media/muli-latin-900italic.f99056b6.woff2";